<template>
  <div class="modal withdraw-modal">
    <div class="overlay" @click="$parent.closeWithdrawModal"></div>
    <div class="wrapper">
      <img src="../img/corners3/top-left-corner.svg" class="top-left" />
      <img src="../img/corners3/top-right-corner.svg" class="top-right" />
      <img src="../img/corners3/bottom-left-corner.svg" class="bottom-left" />
      <img src="../img/corners3/bottom-right-corner.svg" class="bottom-right" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeWithdrawModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <!-- Step 1: Amount + Personal Data -->
                <div v-if="step === 1">
                  <div class="title dark">WITHDRAW</div>
                  <div class="fields">
                    <label>
                      <span class="desc dark">Amount:</span>
                      <input
                        type="text"
                        v-model="amount"
                        @input="allowOnlyNumbers"
                        placeholder="Enter amount"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Email:</span>
                      <input
                        type="email"
                        v-model="email"
                        placeholder="Your email"
                      />
                    </label>
                    <label>
                      <span class="desc dark">First name:</span>
                      <input
                        type="text"
                        v-model="name"
                        placeholder="Your first name"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Last name:</span>
                      <input
                        type="text"
                        v-model="surname"
                        placeholder="Your last name"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Phone:</span>
                      <input
                        type="text"
                        v-model="phone"
                        placeholder="Your phone number"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Country:</span>
                      <select v-model="country" class="country-select">
                        <option value="" disabled selected>Your country</option>
                        <option
                          v-for="item in countryOptions"
                          :value="item.id"
                          :key="item.title"
                        >
                          {{ item.title }}
                        </option>
                      </select>
                    </label>
                    <label>
                      <span class="desc dark">City:</span>
                      <input
                        type="text"
                        v-model="city"
                        placeholder="Your city"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Address:</span>
                      <input
                        type="text"
                        v-model="address"
                        placeholder="Your address"
                      />
                    </label>
                    <label>
                      <span class="desc dark">ZIP Code:</span>
                      <input
                        type="text"
                        v-model="postCode"
                        placeholder="Your zip code"
                      />
                    </label>
                  </div>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="insufficientBalance">
                      Insufficient payout balance. Available:
                      {{ payoutBalanceValue.toFixed(2) }}
                    </div>
                  </transition>
                  <button
                    class="button"
                    :disabled="!step1Valid"
                    @click="goToStep(2)"
                  >
                    NEXT
                  </button>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                </div>

                <!-- Step 2: Choose Payout Method -->
                <div v-if="step === 2">
                  <div class="title dark">CHOOSE PAYOUT METHOD</div>
                  <div class="withdraw-methods">
                    <button
                      class="button method-btn visa-btn"
                      @click="submitCard"
                    >
                      <img src="./../img/visa.svg" alt="Visa" />
                    </button>
                  </div>
                  <button class="button back-btn" @click="goToStep(1)">
                    BACK
                  </button>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                </div>

                <!-- Step 3: SEPA Transfer Details -->
                <div v-if="step === 3">
                  <div class="title dark">SEPA TRANSFER DETAILS</div>
                  <div class="fields">
                    <label>
                      <span class="desc dark">IBAN:</span>
                      <input
                        type="text"
                        v-model="account_number"
                        placeholder="Your IBAN"
                      />
                    </label>
                    <label>
                      <span class="desc dark">First name:</span>
                      <input
                        type="text"
                        v-model="first_name"
                        placeholder="First name"
                      />
                    </label>
                    <label>
                      <span class="desc dark">Last name:</span>
                      <input
                        type="text"
                        v-model="last_name"
                        placeholder="Last name"
                      />
                    </label>
                  </div>
                  <div class="step3-buttons">
                    <button class="button back-btn" @click="goToStep(2)">
                      BACK
                    </button>
                    <button
                      class="button"
                      :disabled="!step3Valid || submitting"
                      @click="submitSepa"
                    >
                      SUBMIT
                    </button>
                  </div>
                  <transition name="fade">
                    <div class="error-desc desc red" v-if="error">
                      {{ error }}
                    </div>
                  </transition>
                  <transition name="fade">
                    <div class="success-desc desc green" v-if="success">
                      {{ success }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "WithdrawModal",
  props: ["currency"],
  data() {
    return {
      step: 1,
      amount: "",
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      city: "",
      address: "",
      postCode: "",
      countryOptions: [],
      account_number: "",
      first_name: "",
      last_name: "",
      error: "",
      success: "",
      submitting: false,
    };
  },
  computed: {
    step1Valid() {
      return (
        this.amount &&
        this.email &&
        this.name &&
        this.surname &&
        this.phone &&
        this.country &&
        this.city &&
        this.address &&
        this.postCode &&
        !this.insufficientBalance
      );
    },
    step3Valid() {
      return this.account_number && this.first_name && this.last_name;
    },
    payoutBalanceValue() {
      return Number(this.$parent.profileData?.payout_balance || 0);
    },
    amountValue() {
      return Number(this.amount || 0);
    },
    insufficientBalance() {
      return this.amountValue > 0 && this.amountValue > this.payoutBalanceValue;
    },
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    goToStep(n) {
      if (n === 2 && this.insufficientBalance) {
        this.error = "Insufficient payout balance";
        return;
      }
      this.error = "";
      this.step = n;
      if (n === 3) {
        this.first_name = this.first_name || this.name;
        this.last_name = this.last_name || this.surname;
      }
    },
    extractErrorMessage(err, fallback) {
      const data = err && err.response && err.response.data;
      if (data && data.errors && typeof data.errors === "object") {
        const firstKey = Object.keys(data.errors)[0];
        const firstValue = firstKey ? data.errors[firstKey] : null;
        if (Array.isArray(firstValue) && firstValue[0]) {
          return firstValue[0];
        }
      }
      return (data && data.message) || fallback;
    },
    getCountries() {
      axios
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response && res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    submitCard() {
      this.error = "";
      this.submitting = true;
      axios
        .post("user/withdraw-requests", { amount: this.amount })
        .then((res) => {
          const withdrawId =
            res.data.id ||
            (res.data.payload && res.data.payload.id) ||
            (res.data.data && res.data.data.id);
          return axios.post(
            "user/withdraw-requests/" + withdrawId + "/payout/card-form",
            {
              email: this.email,
              name: this.name,
              surname: this.surname,
              phone: this.phone,
              country: this.country,
              currency: this.$parent.currencyCode,
              city: this.city,
              address: this.address,
              postCode: this.postCode,
            },
          );
        })
        .then((res) => {
          const redirectUrl =
            res.data.redirect_url ||
            (res.data.payload && res.data.payload.redirect_url);
          if (redirectUrl) {
            window.location = redirectUrl;
          }
        })
        .catch((err) => {
          this.error = this.extractErrorMessage(
            err,
            "Network error. Please try again.",
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submitSepa() {
      if (!this.step3Valid || this.submitting) return;
      this.error = "";
      this.success = "";
      this.submitting = true;
      axios
        .post("user/withdraw-requests", { amount: this.amount })
        .then((res) => {
          const withdrawId =
            res.data.id ||
            (res.data.payload && res.data.payload.id) ||
            (res.data.data && res.data.data.id);
          return axios.post(
            "user/withdraw-requests/" + withdrawId + "/payout/sepa-manual",
            {
              account_number: this.account_number,
              first_name: this.first_name,
              last_name: this.last_name,
            },
          );
        })
        .then(() => {
          this.success = "Withdrawal request submitted successfully!";
          setTimeout(() => {
            this.$parent.closeWithdrawModal();
          }, 1500);
        })
        .catch((err) => {
          this.error = this.extractErrorMessage(
            err,
            "Network error. Please try again.",
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.withdraw-modal {
  .wrapper {
    max-width: 685px;
  }

  .container {
    padding: 52px 16px 0;
    max-height: 100vh;
    overflow: auto;
  }

  .form-fields-wrapper {
    max-width: 460px;
    margin: 0 auto;
    padding-bottom: 50px;
  }

  .title {
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 24px;
  }

  .fields {
    margin-top: 20px;
    display: flex;
    gap: 10px 30px;
    flex-wrap: wrap;
  }

  .fields label {
    display: inline-block;
    width: calc(50% - 20px);
  }

  .fields label input,
  .fields label .country-select {
    margin-top: 8px;
    border-radius: 15px;
    border: 1px solid rgba(145, 145, 145, 0.75);
    background: #3127274d;
    width: 100%;
    box-sizing: border-box;
    padding: 11px 15px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #000;
    outline: none;
  }

  .fields label .country-select {
    cursor: pointer;
    appearance: auto;
    -webkit-appearance: auto;
  }

  .fields label .country-select option {
    background: #ffffff;
    color: #000;
  }

  .fields label .desc {
    font-size: 14px;
    line-height: 24px;
  }

  .withdraw-methods {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 40px;
  }

  .method-btn {
    min-width: 200px;
    justify-content: center;
  }

  .method-btn img {
    height: 24px;
  }

  .back-btn {
    display: block;
    margin: 24px auto 0;
    min-width: 200px;
  }

  .step3-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }

  .step3-buttons .back-btn {
    margin: 0;
  }

  .step3-buttons .button {
    margin: 0;
    min-width: 200px;
  }

  .form-fields-wrapper > div > .button {
    margin: 24px auto 0;
    max-width: 276px;
    display: table;
    width: 100%;
    text-transform: uppercase;
    font-size: 16px;
  }

  .error-desc {
    color: #eb011b;
  }
  .success-desc {
    color: #34b80d;
  }
  .error-desc,
  .success-desc {
    text-align: center;
    margin-top: 12px;
    font-size: 14px;
  }
}

@media screen and (max-width: 768px) {
  .withdraw-modal .container {
    padding: 32px 16px;
  }

  .withdraw-modal .fields label {
    width: 100%;
  }

  .withdraw-modal .withdraw-methods {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .withdraw-modal .method-btn,
  .withdraw-modal .back-btn,
  .withdraw-modal .step3-buttons .button {
    width: 100%;
    max-width: 276px;
  }

  .withdraw-modal .step3-buttons {
    flex-direction: column;
    align-items: center;
  }
}
</style>
